<template>
  <!-- PSU Modal -->
  <div
    class="modal fade"
    id="PackagesStatusModal"
    tabindex="-1"
    aria-labelledby="packagesStatusModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="packagesStatusModalLabel">
            Packages Status
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label style="padding-bottom: 12px">
              Last PSU Requested At:
              {{
                $filters.formatDateAndTime(
                  downloadstore.psuSummary?.lastPsuRequestedAt
                )
              }}
            </label>
            <table class="table table-bordered">
              <tbody>
                <tr>
                  <td class="col-6">AIPs Rejected</td>
                  <td class="col-6">
                    {{ downloadstore.psuSummary?.aipsRejected }}
                  </td>
                </tr>
                <tr>
                  <td>AIPs Stored</td>
                  <td>{{ downloadstore.psuSummary?.aipsStored }}</td>
                </tr>
                <tr>
                  <td>AIPs Failed</td>
                  <td>{{ downloadstore.psuSummary?.aipsFailed}}</td>
                </tr>
                <tr>
                  <td>DIPs Rejected</td>
                  <td>{{ downloadstore.psuSummary?.dipsRejected }}</td>
                </tr>
                <tr>
                  <td>DIPs Stored</td>
                  <td>{{ downloadstore.psuSummary?.dipsStored }}</td>
                </tr>
                <tr>
                  <td>DIPs Failed</td>
                  <td>{{ downloadstore.psuSummary?.dipsFailed}}</td>
                </tr>
              </tbody>
            </table>
            <span v-show="checkPsu()">No package status updates found</span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            style="width: 48.5%"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-success"
            style="width: 48.5%"
            data-bs-dismiss="modal"
            @click="downloadstore.requestPsu(serverParams)"
            :disabled="checkPsu()"
          >
            Request PSU update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useDownloadStore } from "@/stores/download";
import { useAsyncState } from "@vueuse/core";
import { ref } from "vue";

const downloadstore = useDownloadStore();
const props = defineProps({
  serverParams: { type: Object },
});
const serverParams: any = ref(props.serverParams);

const { execute, error } = useAsyncState(() => {
  return downloadstore.checkPsu();
}, null);

const checkPsu = () => {
  if (
    downloadstore.psuSummary?.aipsRejected != 0 ||
    downloadstore.psuSummary?.aipsStored != 0 ||
    downloadstore.psuSummary?.aipsFailed != 0 ||
    downloadstore.psuSummary?.dipsRejected != 0 ||
    downloadstore.psuSummary?.dipsStored != 0 ||
    downloadstore.psuSummary?.dipsFailed != 0 
  ) {
    return false;
  } else return true;
};

//   const selectedPackages = ref();
//   const props = defineProps({
//     checkedId: { type: Array },
//   });

//   watch(
//     () => props.checkedId,
//     (newId) => (selectedPackages.value = newId)
//   );

//   const removeItem = (index: number) => {
//     selectedPackages.value.splice(index, 1);
//   };

//   const submit = () => {
//     console.log(selectedPackages.value);
//   };
</script>

<style scoped>
li {
  padding-right: 10px;
  margin: auto;
  display: inline-block;
}
</style>
